var render, staticRenderFns
import script from "./app-shell-icon.vue?vue&type=script&lang=js"
export * from "./app-shell-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0799ff47')) {
      api.createRecord('0799ff47', component.options)
    } else {
      api.reload('0799ff47', component.options)
    }
    
  }
}
component.options.__file = "src/components/layout/app-shell-icon.vue"
export default component.exports